!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("uuid"), require("styled-components")) : "function" == typeof define && define.amd ? define(["exports", "react", "uuid", "styled-components"], e) : e((n = "undefined" != typeof globalThis ? globalThis : n || self).AnimatedText = {}, n.React, n.uuid, n.styled);
}(this, function (n, e, t, i) {
  "use strict";

  function a(n) {
    return n && "object" == typeof n && "default" in n ? n : {
      default: n
    };
  }
  var r = a(e),
    o = a(i),
    l = function () {
      return l = Object.assign || function (n) {
        for (var e, t = 1, i = arguments.length; t < i; t++) for (var a in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
        return n;
      }, l.apply(this, arguments);
    };
  function u(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }
  var c,
    s,
    d,
    f = o.default.span(c || (c = u(["\n  position: relative;\n  display: inline-block;\n  visibility: hidden;\n"], ["\n  position: relative;\n  display: inline-block;\n  visibility: hidden;\n"]))),
    p = o.default.div(d || (d = u(["\n  @keyframes fragmentletter-", " {\n    0% {\n      opacity: 0;\n      visibility: hidden;\n      transform: translateX(", ")\n        translateY(", ")\n        scale(", ");\n    }\n    100% {\n      oapcity: 1;\n      visibility: visible;\n      transform: translateX(0) translateY(0) scale(1);\n    }\n  }\n\n  & > span {\n    display: inline-block;\n  }\n\n  & ", " {\n    text-decoration: inherit;\n    vertical-align: inherit;\n\n    animation: ", ";\n\n    animation-name: ", ";\n  }\n\n  ", "\n"], ["\n  @keyframes fragmentletter-", " {\n    0% {\n      opacity: 0;\n      visibility: hidden;\n      transform: translateX(", ")\n        translateY(", ")\n        scale(", ");\n    }\n    100% {\n      oapcity: 1;\n      visibility: visible;\n      transform: translateX(0) translateY(0) scale(1);\n    }\n  }\n\n  & > span {\n    display: inline-block;\n  }\n\n  & ", " {\n    text-decoration: inherit;\n    vertical-align: inherit;\n\n    animation: ", ";\n\n    animation-name: ", ";\n  }\n\n  ", "\n"])), function (n) {
      return n.uid;
    }, function (n) {
      var e = n.animation.x;
      return null != e ? e : 0;
    }, function (n) {
      var e = n.animation.y;
      return null != e ? e : 0;
    }, function (n) {
      var e = n.animation.scale;
      return null != e ? e : 1;
    }, f, function (n) {
      var e = n.animation.ease,
        t = n.duration;
      return "".concat(t, "s ").concat(null != e ? e : "ease-in-out", " forwards;");
    }, function (n) {
      var e = n.shouldAnimate,
        t = n.uid;
      return e ? "fragmentletter-".concat(t) : "";
    }, function (n) {
      for (var e = n.count, t = void 0 === e ? 0 : e, a = n.interval, r = "", o = 0; o < t; o += 1) r += "".concat(f, ":nth-of-type(").concat(o + 1, ") {\n            animation-delay: ").concat((a || .04) * o, "s;\n          }");
      return i.css(s || (s = u(["\n      ", "\n    "], ["\n      ", "\n    "])), r);
    }),
    y = {
      blocks: {
        y: "60px",
        interval: .07,
        duration: .7
      },
      wave: {
        y: "40px",
        interval: .04,
        duration: .4,
        ease: "ease-in-out"
      },
      float: {
        x: "200px",
        ease: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",
        duration: 1.2,
        interval: .1
      },
      bounce: {
        y: "200px",
        ease: "cubic-bezier(0.68, -0.55, 0.265, 1.55)"
      },
      throw: {
        y: "200px",
        scale: 2,
        interval: .07
      },
      diagonal: {
        x: "200px",
        y: "-200px",
        ease: "cubic-bezier(0.68, -4.55, 0.265, 1.55)"
      },
      rifle: {
        y: "100px",
        x: "-500px",
        ease: "ease-in",
        duration: .3,
        interval: .03
      },
      lights: {
        y: "-20px",
        ease: "ease-out",
        duration: 1,
        interval: .4
      }
    },
    v = " ",
    m = "words",
    b = {
      y: "-30px"
    };
  n.WHITE_SPACE_CODE = v, n.default = function (n) {
    var i,
      a,
      o,
      u,
      c = n.children,
      s = void 0 === c ? "" : c,
      d = n.type,
      h = void 0 === d ? m : d,
      g = n.interval,
      x = n.duration,
      O = n.animation,
      w = void 0 === O ? b : O,
      k = n.animationType,
      E = void 0 === k ? m : k,
      S = n.tag,
      _ = void 0 === S ? "div" : S,
      j = n.includeWhiteSpaces,
      T = void 0 !== j && j,
      P = n.rootMargin,
      I = n.threshold,
      M = function (n, e) {
        var t = {};
        for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
        if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
          var a = 0;
          for (i = Object.getOwnPropertySymbols(n); a < i.length; a++) e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[a]) && (t[i[a]] = n[i[a]]);
        }
        return t;
      }(n, ["children", "type", "interval", "duration", "animation", "animationType", "tag", "includeWhiteSpaces", "rootMargin", "threshold"]),
      A = e.useState([]),
      H = A[0],
      L = A[1],
      X = e.useState(!1),
      Y = X[0],
      q = X[1],
      z = e.useRef(null),
      D = null !== (i = null == y ? void 0 : y[E]) && void 0 !== i ? i : w;
    e.useEffect(function () {
      if ("string" == typeof s || "number" == typeof s) {
        var n = function (n) {
          var e,
            t = function (n) {
              return n.toString().split(" ");
            }(n);
          return (e = []).concat.apply(e, t.map(function (n, e) {
            return 0 !== e ? [v, n] : [n];
          })).map(function (n) {
            return " " === n ? v : n;
          });
        }(s);
        L(n);
        var e = new IntersectionObserver(function (n, e) {
          n.forEach(function (n) {
            n.isIntersecting && (q(!0), z.current && e.unobserve(z.current));
          });
        }, {
          rootMargin: P || "20%",
          threshold: I || 0
        });
        return z.current && e.observe(z.current), function () {
          L([]), q(!1);
        };
      }
      console.error("Only string (ReactText) is currently allowed as react-animated-text-content component's child. Please, change to proper type.");
    }, [s, h]);
    var R = t.v4();
    return r.default.createElement(p, l({
      as: _,
      count: "words" === h ? H.length : 0,
      interval: g || (null !== (a = null == D ? void 0 : D.interval) && void 0 !== a ? a : .04),
      duration: x || (null !== (o = null == D ? void 0 : D.duration) && void 0 !== o ? o : .4),
      ref: z,
      shouldAnimate: Y,
      uid: R,
      animation: D,
      "data-testid": "animated-text"
    }, M), "words" === h ? function (n, e) {
      return n.map(function (n, t) {
        return n !== v ? r.default.createElement(f, {
          key: t,
          dangerouslySetInnerHTML: {
            __html: n
          }
        }) : e && r.default.createElement(f, {
          key: "".concat(t, "&nbsp;"),
          dangerouslySetInnerHTML: {
            __html: "&nbsp;"
          }
        }) || v;
      });
    }(H, T) : function (n, e, t) {
      var i = -1;
      return n.map(function (n, a) {
        var o = n !== v ? Array.from(n) : [v];
        return o[0] !== v ? r.default.createElement("span", {
          key: a
        }, o.map(function (n, t) {
          return i += 1, r.default.createElement(f, {
            key: t,
            dangerouslySetInnerHTML: {
              __html: n
            },
            style: {
              animationDelay: "".concat(e * i, "s")
            }
          });
        })) : t ? r.default.createElement(f, {
          key: "".concat(a, "&nbsp;"),
          dangerouslySetInnerHTML: {
            __html: "&nbsp;"
          },
          style: {
            animationDelay: "".concat(e * i, "s")
          }
        }) : v;
      });
    }(H, g || (null !== (u = null == D ? void 0 : D.interval) && void 0 !== u ? u : .04), T));
  }, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});